export const NAVIGATION_CORE_MODULE_NAME = '@pressreader/navigation-core';
